












import {Component, Vue, Watch} from 'vue-property-decorator';
import {ModuleOrganization} from '@/store/modules/OrganizationModule';
import {ModuleShop} from '@/store/modules/ShopModule';
import TrackingOrdersChart from '@/screens/dashboard/charts/TrackingOrdersChart.vue';
import {ETrackingOrdersStatus} from '@/models/ITrackingOrder';
import {analyticsTrackingOrdersStatus} from '@/services/AnalyticsService';

@Component({
  components: {TrackingOrdersChart},
})
export default class TrackingOrdersChartFiltration extends Vue {

  loading: boolean = false;
  trackingOrdersStatus: any = [];
  series: any[] = [];

  get organizationId() {
    return ModuleOrganization.organizationId;
  }

  get shopId() {
    return ModuleShop.shopId;
  }

  @Watch('shopId', {immediate: true})
  async loadData() {
    try {
      this.loading = true;
      this.series = [];
      this.trackingOrdersStatus = await analyticsTrackingOrdersStatus(this.organizationId, this.shopId);
      let color = '';
      this.trackingOrdersStatus.map((item: any) => {
        switch (item.status) {
          case ETrackingOrdersStatus.STATUS_INTRANSIT :
            color = 'black';
            break;
          case ETrackingOrdersStatus.STATUS_DELIVERED :
            color = 'green';
            break;
          case ETrackingOrdersStatus.STATUS_UNDELIVERED:
            color = 'orange';
            break;
          case ETrackingOrdersStatus.STATUS_ALERT:
            color = 'pink';
            break;
          case ETrackingOrdersStatus.STATUS_NOTFOUND:
            color = 'red';
            break;
          default:
            color = 'black';
            break;
        }
        const data = {name: item.status, y: item.value, key: item.status, color, drilldown: item.status};
        this.series.push(data);
      });
    } finally {
      this.loading = false;
    }
  }
}
